const labels = {
  title: 'Instacash Backdoor',
  icBvLinking: 'IC BV Linking',
  icBvLinkingFlowType: 'IC Flow type',
  icAddCardModal: 'IC Add Card Modal',
}

export default labels
